import React, { FunctionComponent } from "react";
import { DetailedCartItem } from "../../../../../../../context/CartContext/CartContext.api.types";
import useDevice from "../../../../../../../utils/hooks/useDevice";
import CartDetailedItemComponentDesktop from "./CartDetailedItemDesktop";
import CartDetailedItemComponentMobile from "./CartDetailedItemMobile";

type Props = {
  cartDetailedItem: DetailedCartItem;
  onEdit: (detailedItem: DetailedCartItem) => void;
  onDelete: (detailedItem: DetailedCartItem) => void;
  getLabels: (detailedItem: DetailedCartItem) => LenghtLabel;
};

const CartDetailedItem: FunctionComponent<Props> = ({
  cartDetailedItem,
  onEdit,
  onDelete,
  getLabels,
}) => {
  const { isMobile } = useDevice();

  const labels = getLabels(cartDetailedItem);

  const handleOnDelete = () => {
    onDelete(cartDetailedItem);
  };

  if (isMobile)
    return (
      <CartDetailedItemComponentMobile
        cartDetailedItem={cartDetailedItem}
        onDelete={handleOnDelete}
        onEdit={onEdit}
        labels={labels}
      />
    );

  return (
    <CartDetailedItemComponentDesktop
      cartDetailedItem={cartDetailedItem}
      onEdit={onEdit}
      onDelete={handleOnDelete}
      labels={labels}
    />
  );
};

export default CartDetailedItem;
